import { gql } from '@apollo/client';
import SearchResultFragment from '@/components/common/UniversalSearch/apollo/SearchResult.fragment';

const CreateSearchQueryMutation = gql`
  ${SearchResultFragment}

  mutation CreateSearchQuery($input: CreateSearchQueryInput!) {
    createSearchQuery(input: $input) {
      id
      query
      searchResult {
        ...SearchResultFragment
      }
    }
  }
`;

export default CreateSearchQueryMutation;
